import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";

import { Message, MessageContainer, Position } from "./InputError.Styled";
import { FunctionComponent } from "react";

interface ErrorMessageProps {
	message?:
		| string
		| FieldError
		| Merge<FieldError, FieldErrorsImpl<any>>
		| Partial<{ type: string | number; message: string; }>
		| undefined;
}

const ErrorMessage: FunctionComponent<ErrorMessageProps & Position> = ({
	message,
	...props
}) => {
	if (!message) {
		return null;
	}

	return (
		<MessageContainer {...props}>
			<Message role="alert">{String(message)}</Message>
		</MessageContainer>
	);
};

export default ErrorMessage;
